import React, { useState } from "react";
import Container from "./styled";
import { FaFacebookF } from "react-icons/fa";
import { BsInstagram } from "react-icons/bs";
import { BsWhatsapp } from "react-icons/bs";
import ArrepentimientoSwitch from "./arrepentimiento/switch";
import BajaDeServicioSwitch from "./bajaDeServicio/switch";
import disableScroll from "disable-scroll";

export default function Footer() {
  // Popup arrepentimiento open close
  const [arrepentimiento, setArrepentimiento] = useState(false);
  const [baja, setBaja] = useState(false);
  const [isDisable, setIsDisable] = useState(false);

  const toggleArrepentimiento = () => {
    setArrepentimiento(!arrepentimiento);
    // Disable scroll Off
    disableScroll.off();
  };

  const toggleBaja = () => {
    setBaja(!baja);
    // Disable scroll Off
    disableScroll.off();
  };

  // Popup arrepentimiento disable scroll
  const toggleScroll = () => {
    setIsDisable(!isDisable);
  };

  return (
    <Container>
      {/* Info Navs Container */}
      <div className="infoNavsContainer">
        {/* Column Seguro Bici */}
        <div className="infoContainer">
          {/* Seguro Bici Logo */}
          <a href="/">
            <img alt="Seguro Bici Logo" src="images/logos/segurobici.svg"></img>
          </a>
          {/* Info */}
          <div className="infoTextContainer">
            <p>0810-220-2373</p>
            <p>(011) 5263-2373</p>
            <p>info@segurobici.com.ar</p>
            <p>Suipacha 245 6° Piso CABA</p>
          </div>
          {/* Social Media Container Mobile */}
          <div className="socialMediaContainerMobile">
            {/* Facebook Button */}
            <a href="https://www.facebook.com/SeguroBici/" target="_blank">
              <FaFacebookF />
            </a>
            {/* Instagram Button */}
            <a href="https://www.instagram.com/segurobici/" target="_blank">
              <BsInstagram />
            </a>
            {/* WhatsApp Button */}
            <a
              href="https://api.whatsapp.com/send?phone=541162255399&text=%C2%A1Hola%2C%20me%20gustar%C3%ADa%20obtener%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20Seguro%20de%20Bici!%20"
              target="_blank"
            >
              <BsWhatsapp />
            </a>
          </div>
        </div>
        {/* Navs Container */}
        <div className="navsContainer">
          {/* Column Nav Container */}
          <div className="navColumn">
            {/* Nav Title */}
            <p>Mapa del sitio</p>
            {/* Nav */}
            <nav>
              <li>
                <a href="/">Inicio</a>
              </li>
              <li>
                <a href="https://www.segurobici.com.ar/blog/" target="_blank">
                  Blog
                </a>
              </li>
              <li>
                <a href="/contacto">Contacto</a>
              </li>
            </nav>
          </div>
          {/* Column Nav Container */}
          <div className="navColumn">
            {/* Nav Title */}
            <p>Ayuda</p>
            {/* Nav */}
            <nav>
              <li onClick={toggleScroll}>
                <a onClick={toggleBaja}>Baja del Servicio</a>
              </li>
              <li onClick={toggleScroll}>
                <a onClick={toggleArrepentimiento}>Arrepentimiento de compra</a>
              </li>
              <li>
                <a href="/bicicleterias">Red de Bicicleterias</a>
              </li>
              {/*
              <li>
                <a href="#">Red de Tiendas de Monopatines</a>
              </li> */}
            </nav>
          </div>
          {/* Column Nav Container */}
          <div className="navColumn">
            {/* Nav Title */}
            <p>Legales</p>
            {/* Nav */}
            <nav>
              <li>
                <a href="/privacidad">Políticas de Privacidad</a>
              </li>
              <li>
                <a href="/terminosycondiciones">Terminos y Condiciones</a>
              </li>
            </nav>
          </div>
          {/* Column Nav Container */}
          <div className="navColumn">
            {/* Nav Title */}
            <p>La empresa</p>
            {/* Nav */}
            <nav>
              <li>
                <a href="/nosotros">Sobre nosotros</a>
              </li>
              <li>
                <a href="/misionyvision">Misión y Visión</a>
              </li>
              <li>
                <a href="/formaparte">Forma parte de SeguroBici</a>
              </li>
            </nav>
          </div>
        </div>
      </div>

      {/* Social Media and Data Fiscal Container */}
      <div className="socialMediaDataFiscalContainer">
        {/* Social Media Container */}
        <div className="socialMediaContainer">
          {/* Facebook Button */}
          <a href="https://www.facebook.com/SeguroBici/" target="_blank">
            <FaFacebookF />
          </a>
          {/* Instagram Button */}
          <a href="https://www.instagram.com/segurobici/" target="_blank">
            <BsInstagram />
          </a>
          {/* WhatsApp Button */}
          <a
            href="https://api.whatsapp.com/send?phone=541162255399&text=%C2%A1Hola%2C%20me%20gustar%C3%ADa%20obtener%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20Seguro%20de%20Bici!%20"
            target="_blank"
          >
            <BsWhatsapp />
          </a>
        </div>
        {/* Data Fiscal Container */}
        <div className="dataFiscalContainer">
          <a href="https://www.gyssrl.com.ar/" target="_blank">
            <img
              alt="Logo Gestión y Servicios SRL"
              src="images/logos/gys.svg"
              id="logoGyS"
            ></img>
          </a>
          <img alt="Logo PDP" src="images/logos/pdp.png" id="logoPDP"></img>
          <img alt="Logo SSN" src="images/logos/ssn.png" id="logoSSN"></img>
          <img
            alt="Logo Lets Encrypt"
            src="images/logos/letsencrypt.png"
            id="logoEncrypt"
          ></img>
          <img
            alt="Logo Data Fiscal"
            src="images/logos/datafiscal.png"
            id="logoFiscal"
          ></img>
        </div>
      </div>
      <hr />
      {/* Copyright Text */}
      <p id="copyrightText">
        © Copyright 2022 SeguroBici | Todos los derechos reservados | SeguroBici
        es marca de Gestión y Servicios SRL
      </p>
      {/* Modal Arrepentimiento de Compra */}
      {arrepentimiento && (
        <ArrepentimientoSwitch
          handleClose={toggleArrepentimiento}
          handleScroll={isDisable && toggleScroll}
        />
      )}
      {/* Modal Baja de Servicio */}
      {baja && (
        <BajaDeServicioSwitch
          handleClose={toggleBaja}
          handleScroll={isDisable && toggleScroll}
        />
      )}
    </Container>
  );
}
